
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { BreakdanceNotification } from "@/types/notifications";
import Message from "./Types/Message.vue";
import AjaxCodeError from "./Types/AjaxCodeError.vue";
import NetworkError from "./Types/NetworkError.vue";
import InternalServerError from "./Types/InternalServerError.vue";
import LoggedOutError from "@/components/Notifications/Types/LoggedOutError.vue";
import IoTsError from "@/components/Notifications/Types/IoTsError.vue";
import Icon from "@/components/UI/Icon.vue";
import IconButton from "@/components/UI/IconButton.vue";
import ErrorMessage from "@/components/Notifications/Types/ErrorMessage.vue";
import SessionExpiredError from "@/components/Notifications/Types/SessionExpiredError.vue";
import FriendlyMultiError from "@/components/Notifications/Types/FriendlyMultiError.vue";

@Component({
  components: {
    SessionExpiredError,
    ErrorMessage,
    IconButton,
    Icon,
    IoTsError,
    LoggedOutError,
    Message,
    AjaxCodeError,
    NetworkError,
    InternalServerError,
    FriendlyMultiError
  }
})
export default class NotificationViewer extends Vue {
  @Prop()
  value!: BreakdanceNotification;

  clear() {
    this.$emit("clear");
  }
}
